import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermValue } from '../../../packages/JsonQuery';

export const selectHasWasher = createSelector(selectJsonQuery, jsonQuery => getTermValue('has_washer')(jsonQuery));
